export const borderRadius = {
    medium: '4px',
};

export const border = {
    thin: '1px solid',
};
